
import apiClient from "../../utils/apiclient";


export const getTasks = async (token: string, page: number, limit: number,searchQuery:string,sortOption:string) => {
  return await apiClient.get('/admin/task/get-all-task-v1', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      limit,
      searchQuery,
      sortOption
    },
  });
};
export const getPendingapprovedTasks = async (token: string, page: number, limit: number, status: string,search:string,sortOption:string) => {
  return await apiClient.post(
    '/admin/task/pending-and-approved-tasks',
    {
      status,
      page,
      limit,
      search,
      sortOption
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


export const duplicatetasks = async (token: string, task_id: string) => {
  return await apiClient.post(
    '/admin/task/duplicate-tasks',
    {
      task_id,
     
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const approveTask = async (token: string, task_id: string, approved: boolean) => {
  return await apiClient.post(
    "/admin/task/approve-task", // replace with your actual endpoint
    {
      task_id,
      approved, // true for approve, false for reject
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};